import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";  // Core styles
import "swiper/css/navigation";  // Navigation styles
import "swiper/css/pagination";  // Pagination styles
// import "swiper/swiper-bundle.min.css"; // Import Swiper styles

const Slider = () => {
  const images = [
    '/images/tours/a1.jpg',
    '/images/tours/a2.jpg',
    '/images/tours/a3.jpg',
    '/images/tours/a4.jpg',
    '/images/tours/a5.jpg',
    '/images/tours/a6.jpg',
    '/images/tours/a7.jpg',
    '/images/tours/a8.jpg',
  
    '/images/tours/1.jpg',
    '/images/tours/2.jpg',
    '/images/tours/3.jpg',
    '/images/tours/5.jpg',
    '/images/tours/6.jpg',
    '/images/tours/7.jpg',
    '/images/tours/8.jpg',
    '/images/tours/9.jpg',
    '/images/tours/10.jpg',
    '/images/tours/11.jpg',
    '/images/tours/12.jpg',
    '/images/tours/13.jpg',
    '/images/tours/14.jpg',
    '/images/tours/17.jpg',
    '/images/tours/18.jpg',
    '/images/tours/19.jpg',
    '/images/tours/20.jpg',
    '/images/tours/21.jpeg',
    '/images/tours/22.jpg',
    '/images/tours/23.jpeg',
  ];
  

  return (
    <div className="mx-4 lg:mx-10 mb-20 ">
      <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-center pb-0 lg:pb-10 pt-10 text-gray-800 ">
        Past Tours
      </h1>
      <Swiper
        modules={[Navigation,  Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        // pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 },
          640: { slidesPerView: 1, spaceBetween: 10 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}
        className="relative cursor-pointer"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index} className="flex justify-center items-center">
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="w-full h-[400px] object-cover rounded-lg"
            />
          </SwiperSlide>
        ))}

        {/* Custom Left Arrow */}
        {/* <div className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 w-4 h-1 bg-black text-black rounded-full flex justify-center items-center shadow-md cursor-pointer z-10">
          <span className="text-xl font-bold">←</span>
        </div> */}

        {/* Custom Right Arrow */}
        {/* <div className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-white text-black rounded-full flex justify-center items-center shadow-md cursor-pointer z-10">
          <span className="text-xl font-bold">→</span>
        </div> */}
      </Swiper>
    </div>
  );
};

export default Slider;
